/**
 * Talks to the slot provider's own API (server-authoritative). The client is
 * served BY the provider, so the API base is same-origin ('') by default; a dev
 * override is available via VITE_PROVIDER_API.
 */
const BASE = (import.meta.env.VITE_PROVIDER_API as string | undefined) ?? '';

export interface SessionConfig {
  sessionId: string;
  gameId: string;
  playerName: string;
  currency: string;
  bet: number;
  balance: number;
  featureSpins: number;
  spinsLeft: number;
  spinsDone: number;
  totalWin: number;
  status: 'playing' | 'completed';
  special: string;
  paytable: Array<{ id: string; pays: Record<string, number>; scatter?: boolean; wild?: boolean }>;
  paylines: number[][];
}

export interface LineWin {
  lineIndex: number;
  symbol: string;
  count: number;
  amount: number;
}

export interface SpinResponse {
  reels: string[][];
  win: number;
  winningLines: number[];
  /** Per-line detail (newer servers); fall back to winningLines when absent. */
  lineWins?: LineWin[];
  scatterWin?: number;
  expandWin?: number;
  expanded: { symbol: string; reels: number[]; preReels?: string[][] } | null;
  special: string;
  spinsLeft: number;
  spinsDone: number;
  totalWin: number;
  balance: number;
  done: boolean;
}

export class ProviderClient {
  constructor(private token: string) {}

  async config(): Promise<SessionConfig> {
    const r = await fetch(`${BASE}/api/sessions/${this.token}`);
    if (!r.ok) throw new Error(`session config ${r.status}`);
    return r.json();
  }

  async spin(): Promise<SpinResponse> {
    const r = await fetch(`${BASE}/api/sessions/${this.token}/spin`, { method: 'POST' });
    if (!r.ok) throw new Error(`spin ${r.status}`);
    return r.json();
  }
}
